import Home from "./components/home.js"
import {HashRouter as Router, Route, Routes} from 'react-router-dom';
import ReactGA from "react-ga";


function App() {
  
  ReactGA.initialize('UA-43997587-9');
  ReactGA.pageview(window.location.pathname + window.location.search);

  return (
    <Router basename="/" hashtype="slash">
      
        <Routes>
          <Route path="/" element={<Home />} /> 
        </Routes>
      
    </Router>
  );
}

export default App;
